const EDGE = 'EDGE'
const HASTY = 'HASTY'
const ADVANCED = 'ADVANCED'

const objects = {
    [EDGE]: {
        type: EDGE,
        label: 'EdgeRelay',
        image: '/images/relays/edge-relay.png',
    },
    [HASTY]: {
        type: HASTY,
        label: 'HastyRelay',
        image: '/images/relays/hasty-relay.png',
    },
    [ADVANCED]: {
        type: ADVANCED,
        label: 'AdvancedRelay',
        image: '/images/relays/advanced-relay.png',
    },
}

export default Object.freeze(objects)

export const byValue = (value) => {
    return objects[value.toUpperCase()]
}
